import { render, staticRenderFns } from "./addDescription.vue?vue&type=template&id=f2d8157c&"
import script from "./addDescription.vue?vue&type=script&lang=js&"
export * from "./addDescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports